var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Category',{attrs:{"cate-name":"news","category-name":"MAG2 NEWS賞","category-intro":"総合ニュースサイト「MAG2 NEWS」で今年紹介したメルマガ記事の中から、アクセス数、SNSシェア数をもとにセレクトしました。"}})}
var staticRenderFns = []

export { render, staticRenderFns }